<script lang="ts" setup>
import { useCvButtonNavigation } from './useCvButtonNavigation';

const { cvButtonTo } = useCvButtonNavigation();
</script>

<template>
  <div :class="$style.container">
    <NuxtLink :class="$style['free-link']" :to="cvButtonTo" variant="conversion"
      >診断をはじめる
      <span :class="$style['free-link__label']">無料</span>
    </NuxtLink>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 400px;
  border-radius: 6px;
  background: linear-gradient(to right, #ff5e00, #ffc412);
  @include mobile-only {
    width: 312px;
  }
}

.free-link {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: 900;
  line-height: 40px;
  padding: 16px 0;
  box-shadow: $shadow-12;
  color: $color-text-and-object-high-emphasis-inverse;

  @include mobile-only {
    font-size: 24px;
  }

  &__label {
    padding: 6px 12px 5px;
    border-radius: 9999em;
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    line-height: 28px;
    color: $color-text-and-object-high-emphasis;
    background-color: $color-okaneko-yellow;
    text-align: center;
    letter-spacing: 0.2em;
    text-indent: 0.2em;
  }
}
</style>
